import Timeline from './timeline';
import './timeline.scss';

export default Timeline;
